var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:_vm.icon,attrs:{"title":_vm.$t(_vm.label)}})
}
var staticRenderFns = []

export { render, staticRenderFns }